<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <PageHeader :title="title" :items="items" />
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="start_date">From</label>
                                <datepicker
                                    v-model="search_data.start_date"
                                    id="start_date"
                                    name="start_date"
                                    :format="customStartDate"
                                    placeholder="Start Date"
                                ></datepicker>
                                <!--                <div class="text-danger" v-if="errors.has('start_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Start date must be greater then end date</div>-->
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="end_date">To</label>
                                <datepicker
                                    v-model="search_data.end_date"
                                    id="end_date"
                                    name="end_date"
                                    :format="customEndDate"
                                    placeholder="End Date"
                                ></datepicker>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="ep_ids">EP IDs</label>
                                <textarea
                                    v-model="search_data.ep_ids"
                                    name="ep_ids"
                                    id="ep_ids"
                                    cols="30"
                                    rows="4"
                                    placeholder="EP IDs separated by comma"
                                    class="form-control form-control-sm"
                                ></textarea>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
                    </form>
                </b-card>

                <b-card>
                    <div class="mb-1" v-if="seses.total > 0">
                        <div class="form-row">
                            <div class="col-md-6">
                                <span class="badge badge-success">Total Search Data Found: {{ seses.total }}</span>
                            </div>
                            <div class="col-md-6">
                                <download-excel
                                    class="btn btn-success float-right"
                                    :fetch="fetchData"
                                    :fields="ep_fields"
                                    :meta="json_meta"
                                    :before-generate="startDownload"
                                    :before-finish="finishDownload"
                                    worksheet="payment-statement"
                                    name="payment-statement.xls"
                                >
                                    Download Excel
                                </download-excel>
                            </div>
                        </div>
                    </div>

                    <div class="scrollable-table table-responsive mb-0" style="overflow-x: auto">
                        <table class="table table-striped" id="titledExcel">
                            <thead>
                                <tr>
                                    <th>Sl.</th>
                                    <th>EP ID</th>
                                    <th>AGL</th>
                                    <th>AGWB</th>
                                    <th>RRC</th>
                                    <th>AGS</th>
                                    <th>TG</th>
                                    <th>RG</th>
                                    <th>TG PCR/CPR</th>
                                    <th>DRG PCR/CPR</th>
                                    <th>AGT</th>
                                    <th>CGVFT</th>
                                    <th>CGSCFS</th>
                                    <th>CGSLL</th>
                                    <th>RVS</th>
                                    <th>CGBIT</th>
                                    <th>CGEE</th>
                                    <th>RARO</th>
                                    <th>RARI</th>
                                    <th>MG</th>
                                    <th>CGVMH</th>
                                    <th>CGVFH</th>
                                    <th>CGNUC</th>
                                    <th>CGIDCI</th>
                                    <th>CGLIP</th>
                                    <th>CGUAI</th>
                                    <th>Total Amount (BDT)</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ses, index) in seses.data" :key="index">
                                    <td>{{ seses.from + index }}</td>
                                    <td>{{
                                        ses.ses_ep ? epIdWithPaymentStatus(ses.ses_ep.ep_id, ses.ses_ep.is_paid) : ''
                                    }}</td>
                                    <td>{{ parseFloat(ses.AGL).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.AGWB).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.RRC).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.AGS).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.TG).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.RG).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.TG_PCR_CPR).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.DRG_PCR_CPR).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.AGT).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGVFT).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGSCFS).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGSLL).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.RVS).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGBIT).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGEE).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.RARO).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.RARI).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.MG).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGVMH).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGVFH).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGNUC).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGIDCI).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGLIP).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.CGUAI).toFixed(2) }}</td>
                                    <td>{{ parseFloat(ses.total_amount).toFixed(2) }}</td>
                                    <td>{{ customDate(ses.created_at) }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="loader" class="loader">Loading...</div>
                        <h5 class="text-center text-secondary" v-if="seses.total === 0 || !flag">
                            No Data Found
                        </h5>
                        <div class="float-right mt-1">
                            <pagination :data="seses" :limit="2" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import XLSX from 'xlsx'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { epIdWithPaymentStatus } from '@src/utils/format-epid'

export default {
    page: {
        title: 'List of Payment Statement',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader, Datepicker },
    data() {
        return {
            title: 'List of Payment Statement',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'List of Payment Statement',
                    active: true,
                },
            ],
            search_data: {
                ep_ids: '',
                start_date: '',
                end_date: '',
            },
            mouzas: [],
            districts: [],
            seses: {},
            flag: false,
            loader: false,
            ep_fields: {
                'EP ID': 'ses_ep.ep_id',
                AGL: 'AGL',
                AGWB: 'AGWB',
                RRC: 'RRC',
                AGS: 'AGS',
                TG: 'TG',
                RG: 'RG',
                'TG PCR/CPR': 'TG_PCR_CPR',
                'DRG PCR/CPR': 'DRG_PCR_CPR',
                AGT: 'AGT',
                CGVFT: 'CGVFT',
                CGSCFS: 'CGSCFS',
                CGSLL: 'CGSLL',
                RVS: 'RVS',
                CGBIT: 'CGBIT',
                CGEE: 'CGEE',
                RARO: 'RARO',
                RARI: 'RARI',
                MG: 'MG',
                CGVMH: 'CGVMH',
                CGVFH: 'CGVFH',
                CGNUC: 'CGNUC',
                CGIDCI: 'CGIDCI',
                CGLIP: 'CGLIP',
                CGUAI: 'CGUAI',
                'Total Amount (BDT)': 'total_amount',
                'Created Date': 'created_at',
            },
            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8',
                    },
                ],
            ],
        }
    },

    mounted() {},
    methods: {
        epIdWithPaymentStatus: epIdWithPaymentStatus,
        customDate(date) {
            return moment(date).format('LL')
        },
        customStartDate(date) {
            this.search_data.start_date = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        customEndDate(date) {
            this.search_data.end_date = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        search() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.flag = true
                    this.loader = true
                    http.post('api/payment/statement/search', this.search_data).then((response) => {
                        if (!response.error) {
                            this.flag = true
                            this.loader = false
                            this.seses = response.data.seses
                        }
                    })
                }
            })
        },
        getResults(page = 1) {
            this.flag = true
            this.loader = true
            http.post('api/payment/statement/search?page=' + page, this.search_data).then((response) => {
                this.flag = true
                this.loader = false
                this.seses = response.data.seses
            })
        },
        onexport(evt) {
            var tbl = document.getElementById('titledExcel')
            var wb = XLSX.utils.table_to_book(tbl)
            XLSX.writeFile(wb, 'payment-statement.xlsx')
        },
        async fetchData() {
            const response = await http.post('api/payment/statement/download', this.search_data)
            return response.data.seses
        },
        startDownload() {
            alert('It will take some time, Loading...')
        },
        finishDownload() {
            alert('Download completed.')
        },
    },
    computed: {
        userPermission() {
            return this.$store.state.user
        },
    },
    created() {
        this.$store.dispatch('getUserPermission')
    },
}
</script>
<style>
.vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
}
</style>
